import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import globalStyles from '../../../../shared/styles/GlobalStyles.module.scss'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { WhatHappenedFlow, WhatWentWrongFlow } from '../../pageFlowData'
import { whatHappenedData } from './data'

export const WhatHappened: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    order: { whatHappened },
  } = state

  const handleTracking = (id: string) => {
    const trackingAnswer = `question | ${WhatHappenedFlow.VIEW_NAME} | ${id}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_WHAT_HAPPENED', data: id })
    dispatch({ type: 'UPDATE_STEP', data: WhatWentWrongFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: WhatWentWrongFlow.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string) => {
    handleTracking(id)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = whatHappenedData

  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage
        buttons={buttons}
        defaultValue={whatHappened ? whatHappened : ''}
        fitContent
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        title={title}
      />
    </div>
  )
}
